import { zodResolver } from '@hookform/resolvers/zod'
import { Grid } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Region } from '~/shared/api'
import { Button } from '~/shared/ui/Buttons'
import {
  AsyncAutocompleteInput,
  FormProvider,
  TextInput,
} from '~/shared/ui/Form'
import { PlusIcon } from '~/shared/ui/Icons'
import { formSchema, FormValues } from './model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
  excludeRegions: string
}

export function Form({ onSuccess, isSubmitting, excludeRegions }: FormProps) {
  const { t } = useTranslation()
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.region'
            placeholder='form.select region'
            name='regionId'
            fetchOptions={(search) =>
              Region.fetchOptionsByExclude(search, excludeRegions)
            }
            readOnly={isSubmitting}
            queryKey={[excludeRegions]}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            name='dispatcher'
            label='form.dispatcher'
            placeholder='form.enter dispatcher full name'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.controller'
            name='controller'
            placeholder='form.enter controller full name'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.medic'
            name='doctor'
            placeholder='form.enter medic full name'
            readOnly={isSubmitting}
          />
        </Grid>
      </Grid>
      <br />
      <Button
        loading={isSubmitting}
        startDecorator={<PlusIcon />}
        fullWidth
        type='submit'
      >
        {t('button.add')}
      </Button>
    </FormProvider>
  )
}
